import React, {useContext, useRef, useState} from 'react';

// kendo react
import {DatePicker} from "@progress/kendo-react-dateinputs";
import {Button} from "@progress/kendo-react-buttons";
import {pencilIcon} from "@progress/kendo-svg-icons";
import {addDays} from "@progress/kendo-date-math";
import {GeneralContext, SearchProductContext, SelectedProductContext} from "../FSARequestLicenseContext";
import {DateGridContext as SearchDateContext} from "./SearchedProductsGrid";
import {DateGridContext as SelectDateContext} from "./SelectedProductsGrid";
import UserContext from "../../common/UserContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {
    mainMessages, minDurationPopoverKey,
    minEndDateKey,
} from "../../../assets/text/MultilingualText";
import KSMPopover from "../../common/Popovers";
import {convertDateFormat} from "../../common/Grid";

export const StartDatePickerCell = (props) => {
    const {
        minDate,
        maxDate,
    } = useContext(GeneralContext);

    const field = props.field;
    const value = props.dataItem[field];

    // bound input events and values to the Grid
    const onChange = (ev) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: ev.syntheticEvent,
                value: ev.target.value,
            });
        }
    };

    const min = minDate
    const max = maxDate

    return <td>
        <DatePicker
            min={min}
            max={max}
            value={value}
            onChange={onChange}
            format="MMMM d, y"
            disabled={true} //start date cannot be set the future
            // valid={props.dataItem['start_date_valid'] && !props.dataItem['exceedError']}
        />
    </td>
}

export const EndDatePickerCell = (props) => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        maxDate,
        headerInfo,
        licenseStartDateKey,
    } = useContext(GeneralContext);

    const field = props.field;
    const value = props.dataItem[field];
    const valid = props.dataItem['end_date_valid'] && !props.dataItem['exceedError']

    const localization = useLocalization();
    const anchor = useRef(null);
    const [popoverShow, setPopoverShow] = useState(false)

    const onMouseOver = () => {
        if(!props.dataItem['end_date_valid']){
            setPopoverShow(true);
        } else{
            setPopoverShow(false);
        }

    };

    const onMouseOut = (ev) => {
        let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
        if (!isChildEl) setPopoverShow(false);
    };


    // bound input events and values to the Grid
    const onChange = (ev) => {
        if (props.onChange) {
            setPopoverShow(false);
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: ev.syntheticEvent,
                value: ev.target.value,
            });
        }
    };

    let minEndDate = addDays(props.dataItem[licenseStartDateKey], headerInfo['minimum_duration'])
    if(minEndDate > maxDate){
        minEndDate = maxDate
    }

    return <td>
        <div ref={anchor} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <DatePicker
                min={minEndDate}
                max={maxDate}
                value={value}
                onChange={onChange}
                format="MMMM d, y"
                valid={valid}
            />
        </div>
        <KSMPopover
            show={popoverShow}
            anchor={anchor.current}
            position={'left'}
            type={'error'}
            style={{
                maxWidth: '25rem'
            }}
            message={<div>
                <b>{localization.toLanguageString(minEndDateKey, mainMessages[siteLanguageDefault][minEndDateKey])}: {convertDateFormat(minEndDate)}</b>
                <br/>
                {localization.toLanguageString(minDurationPopoverKey, mainMessages[siteLanguageDefault][minDurationPopoverKey])}
                <br/>
            </div>}
        />
    </td>
}


export const SearchedDateHeaderCell = (props) => {
    const {
        searchedProducts: items,
    } = useContext(SearchProductContext);

    const {
        visible,
        setVisible,
        setAnchor,
        setFieldName,
    } = useContext(SearchDateContext);

    const buttonRef = useRef(null);
    const disabled = items.length === 0

    return <DateHeaderCell
        title={props.title}
        buttonRef={buttonRef}
        visible={visible}
        setVisible={setVisible}
        setAnchor={setAnchor}
        setFieldName={setFieldName}
        disabled={disabled}
        fieldName={props.field}
    />
};

export const SelectDateHeaderCell = (props) => {
    const {
        selectedProducts: items,
    } = useContext(SelectedProductContext);

    const {
        visible,
        setVisible,
        setAnchor,
        setFieldName,
    } = useContext(SelectDateContext);

    const buttonRef = useRef(null);
    const disabled = items.length === 0 || items.filter(item => item.selected).length === 0;

    return <DateHeaderCell
        title={props.title}
        buttonRef={buttonRef}
        visible={visible}
        setVisible={setVisible}
        setAnchor={setAnchor}
        setFieldName={setFieldName}
        disabled={disabled}
        fieldName={props.field}
    />
};


const DateHeaderCell = (props) => {
    const {
        title,
        buttonRef,
        visible,
        setVisible,
        setAnchor,
        setFieldName,
        disabled,
        fieldName,
    } = props

    return <span className="k-cell-inner">
        <span className="k-link">
            <span className="k-column-title">
               {title}
            </span>
            <Button
                className="ksm-default-header"
                svgIcon={pencilIcon}
                ref={buttonRef}
                onClick={() => {
                    setAnchor(buttonRef.current.element)
                    setVisible(!visible)
                    setFieldName(fieldName)
                }}
                style={{
                    color: "!inherit"
                }}
                disabled={disabled}
            />
        </span>
    </span>
};

